module.exports = __webpack_public_path__ + "img/image05.3e83357a.jpg";